import {containerTypes} from './constants/comments';

export const isValidContainer = (containerType = '') => containerType && containerTypes.includes(containerType);

export const isViaSlack = comment => /slack/i.test(((comment && comment.sourceData) || {}).name || '');

export const isViaTeams = comment => /teams/i.test(((comment && comment.sourceData) || {}).name || '');

export const removeOuterPTags = string => string && string.replace(/^<p>/, '').replace(/<\/p>$/, '');
